function customRadioNo(groupName) {
      return {
        selectedId: null,
        selectedTitleProduct: '',
        selectedPriceProduct: '',
        

    toggle(event) {
      const el = event.currentTarget;
      const id = el.dataset.v;
      const title = el.dataset.title;
      const priceText = el.dataset.price;
      const price = el.dataset.proprice;
      const required = this.$el.hasAttribute('required');
      
       
      if (this.selectedId === id) {
       
      }else{
        this.selectedId = id;
        this.selectedTitleProduct = title;
        this.selectedPriceProduct = priceText;
      
        this.$dispatch('update-selection', { groupName, price: Number(price) });
        
      }
    }
  }
  }
function customRadioGroup(groupName) {
  return {
    selectedId: null,
    selectedTitleProduct: '',
    selectedPriceProduct: '',

    toggle(event) {
      const el = event.currentTarget;
      const id = el.dataset.v;
      const title = el.dataset.title;
      const priceText = el.dataset.price;
      const price = el.dataset.proprice;
      const required = this.$el.hasAttribute('required');
      
       
      if (this.selectedId === id) {
        if (!required) {
          
         this.selectedId = null;
          this.selectedTitleProduct = '';
          this.selectedPriceProduct = '';
          this.$dispatch('update-selection', { groupName, price: 0 });
         
        }
      }else{
        this.selectedId = id;
        this.selectedTitleProduct = title;
        this.selectedPriceProduct = priceText;
        
        this.$dispatch('update-selection', { groupName,  price: Number(price) });
        
      }
    }
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.data('customProductForm', () => ({
    baseRegular: 0,
    baseSale: 0,
    selections: {},

    init() {
     
      this.cacheBasePrices()
      // this.selections = {};
      window.addEventListener('update-selection', (e) => {
        this.updateSelection(e.detail.groupName, e.detail.price);
      });
      // this.updatePriceDisplay(); // 初始化一次
    },

    updateSelection(groupName, price) {
     
      this.selections[groupName] = Number(price || 0);
      this.updatePriceDisplay();
      
    },
        cacheBasePrices() {
          const parseUSD = str => Number(str.replace(/[^0-9.]/g, '') || 0);
          const regularEl = document.querySelector('.price__sale .price-item--regular');
          // console.log("regularEl111",regularEl)
          const saleEl = document.querySelector('.price__sale .price-item--sale') ;
    
          const onlyregularEl = document.querySelector('.price__regular .price-item.price-item--regular');
    
          if (regularEl) {
            // const baseRegStr = regularEl.textContent.replace(/[^0-9.]/g, '');
            this.baseRegular = parseUSD(regularEl?.textContent || '')
          }
    
          if (saleEl) {
            // const baseSaleStr = saleEl.textContent.replace(/[^0-9.]/g, '');
            this.baseSale = parseUSD(saleEl?.textContent || '')
          }

           if (onlyregularEl) {
            // const baseSaleStrp = onlyregularEl.textContent.replace(/[^0-9.]/g, '');
            this.onebaseRegular = parseUSD(onlyregularEl?.textContent || '')
          }
          this.updatePriceDisplay()
        },
    
        refresh() {
          this.updatePriceDisplay()
      },
    
    updatePriceDisplay() {
       const parseUSD = str => Number(str.replace(/[^0-9.]/g, '') || 0);
      const extras = Object.values(this.selections).reduce((sum, p) => sum + p, 0);
      
      const regEl = document.querySelector('.price__sale .price-item--regular');
      const saleEl = document.querySelector('.price__sale .price-item--sale');
      const onlyregularEl = document.querySelector('.price__regular .price-item.price-item--regular');

      if (regEl) regEl.textContent = this.formatUSD(this.baseRegular + extras);
      if (saleEl) saleEl.textContent = this.formatUSD(this.baseSale + extras);
      if (onlyregularEl) onlyregularEl.textContent = this.formatUSD(this.onebaseRegular + extras);
    },

    formatUSD(num) {
      return `$${num.toLocaleString(undefined, { minimumFractionDigits: 2 })} USD`;
    }
  }));
});